import * as Sentry from '@sentry/browser';
import {BrowserTracing} from '@sentry/tracing';
import {config} from 'helpers';

interface Options {
  extra?: any;
  filename?: string;
  func?: {name: string};
  output?: boolean;
}

if (!config.development && config.sentryDSN && !config.webWorker) {
  Sentry.init({
    dsn: config.sentryDSN,
    ignoreErrors: ['NetworkError'],
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0
  });
}

export function handleError(error: Error, {func, filename, extra, output = true}: Options = {}) {
  if (!config.webWorker) {
    Sentry.withScope(scope => {
      if (func) {
        scope.setExtra('filename', filename);
        scope.setExtra('func', func.name);
      }
      if (extra) {
        scope.setExtra('extra', extra);
      }
      Sentry.captureException(error);
    });
  }
  if (config.development && output) {
    console.error(error);
    if (func) {
      console.error('The error above occured in ', func.name, filename);
    }
    if (extra) {
      console.error(extra);
    }
  }
}
